import { useTranslation } from 'react-i18next';
import moment from 'moment/moment'

import { downloadString } from 'utils'

const useExport = ({ssids}) => {
  const { t } = useTranslation();

  const create = async () => {
    const headers = [
      'supervision.tables.label_col',
      'supervision.tables.accesspoint_col',
      'supervision.tables.locations_col',
    ]

    const translatedHeaders = headers.map(header => t(header).toUpperCase())

    const data = ssids
      .flatMap(({ssid_name, sites}) => {
        return sites.map(site => ([ssid_name || '-', site.total_equipments, site.name || '-'].join(',')))
      })
      .join('\r\n')

    const dataString = `data:text/csv;charset=utf-8,${translatedHeaders.join(',')}\r\n${data}`
    await downloadString({ dataString, fileName: `ssids_${moment().format('YYYY/MM/DD HH:mm')}.csv` })
  }

  return create
}

export default useExport

